import { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import * as FilterHelpers from '../helpers/changelog/filter'
import * as DataHelpers from '../helpers/changelog/data'

const useChangelogFilter = baseFilter => {
  const [initialFilter, setInitialFilter] = useState({ months: [], apps: [], changeTypes: [] })
  const [filter, setFilter] = useState(initialFilter)
  const { t: translateHelper } = useTranslation()

  useEffect(() => {
    const filterBuilded = FilterHelpers.builderFilter(baseFilter, translateHelper)

    setInitialFilter(filterBuilded)
    setFilter(filterBuilded)
  }, [baseFilter, translateHelper])

  return {
    initialFilter,
    filter,
    setFilter,
  }
}

const useChangelogFilterOnChange = (initialData, setData, filter) => {
  useEffect(() => {
    const filterGroup = FilterHelpers.getFiltersSelected(filter)
    const countFilterSelected = FilterHelpers.getCountFilterSelected(filterGroup)
    const hasFilterSelected = countFilterSelected > 0
    let data

    if (hasFilterSelected) {
      data = initialData.reduce((accGroup, dataGroupMonth) => {
        const logFiltered = dataGroupMonth.edges.reduce((accLog, log) => {
          const isLogFiltered = DataHelpers.getIsLogFiltered(log, filterGroup)
          return isLogFiltered ? [...accLog, log] : accLog
        }, [])

        return logFiltered.length ? [...accGroup, { edges: [...logFiltered] }] : accGroup
      }, [])
    }
    setData(data || initialData)
  }, [initialData, setData, filter])
}

const useChangelogOnSelectFilter = (filter, setFilter) => {
  const onSelectFilter = useCallback(
    (filterGroup, filterSelected) => {
      const filterGroupSelected = filter[filterGroup]
      const filterGroupUpdated = FilterHelpers.filterToggleSelect(filterSelected, filterGroupSelected)
      const filterUpdated = {
        ...filter,
        [filterGroup]: filterGroupUpdated,
      }
      setFilter(filterUpdated)
    },
    [filter, setFilter]
  )

  return {
    onSelectFilter,
  }
}

const useClearFilter = (initialFilter, setFilter) => {
  const onClearFilter = useCallback(() => {
    setFilter(initialFilter)
  }, [initialFilter, setFilter])

  return {
    onClearFilter,
  }
}

export { useChangelogFilter, useChangelogFilterOnChange, useChangelogOnSelectFilter, useClearFilter }
